define('searchParams',['configDefaultSearchParams'], function (configDefaultSearchParams) {
  const searchParametersElement = document.querySelector('#searchParametersJSON, [data-search-params]');
  let searchParameters = {};
  let defaultParameters = {
    Adult: false,
    AgeRestricted: false,
    Bathrooms: 0,
    Bedrooms: 0,
    BrandId: 0,
    Brands: [],
    CommName: '',
    CommunityStatus: '',
    Custom: false,
    CustomResults: false,
    ExcludeBrandsFromResults: true,
    ExcludeRegularComms: false,
    Gated: false,
    GolfCourse: false,
    Green: false,
    Qmi: false,
    HomeStatus: '',
    HotDeals: false,
    IncludeMpc: true,
    LuxuryHomes: false,
    Mfr: false,
    MultiFamily: false,
    NatureAreas: false,
    NoBoyl: true,
    NumStory: 0,
    Parks: false,
    Pool: false,
    PriceHigh: 0,
    PriceLow: 0,
    SchoolDistrictIds: '',
    SingleFamily: false,
    Sports: false,
    SqFtHigh: 0,
    SqFtLow: 0,
    Views: false,
    Waterfront: false,
    Garages: 0,
    LivingAreas: 0,
    Stories: 0,
    MasterBedLocation: 0,
    CommId: 0,
    BrandId: 0,
    HasRVGarage: false,
    HasBuilderReviews: false,
    ComingSoon: false
  }

  defaultParameters = Object.assign(defaultParameters, getParametersConfig());

  if (searchParametersElement) {
    searchParameters = JSON.parse(searchParametersElement.value);

    if (!searchParameters.Brands) {
      searchParameters.Brands = [];
    }

    if (!searchParameters.CommName) {
      searchParameters.CommName = '';
    }

    if (!searchParameters.CommunityStatus) {
      searchParameters.CommunityStatus = '';
    }

    // Hack => ExcludeBasicListings has JsonIgnore attribute in the BDX Web API so we cannot init the value from the Json element.
    if (typeof searchParameters.ExcludeBasicListings === "undefined" && searchParameters.ShouldExcludeBasicListings) {
          searchParameters.ExcludeBasicListings = true;
    }
    else {
      searchParameters.ExcludeBasicListings = false;
    }

    if (!searchParameters.HomeStatus) {
      searchParameters.HomeStatus = '';
    }

    if (!searchParameters.SchoolDistrictIds) {
      searchParameters.SchoolDistrictIds = '';
    }
  } else {
    searchParameters = Object.assign({}, defaultParameters);
  }

  function defaultSearchParams() {
    var radius = { 'Radius': 0, 'WebApiSearchType': 'Exact' };

    if (searchParameters.City || searchParameters.County || searchParameters.PostalCode) {
      radius = { 'Radius': 25, 'WebApiSearchType': 'Radius' };
    }

    if (searchParameters.AllowStateSearch === 1) {
      radius = { 'WebApiSearchType': 'State' };
    }

    return Object.assign({}, defaultParameters, radius);
  }

  function getParametersConfig() {
    return Object.assign({}, configDefaultSearchParams.getDefaultSearchParams());
  }

  function getSearchParameters() {
    if ('Distance' === searchParameters.SortBy && !searchParameters.Mfr) {
      searchParameters.SortBy = 'Random';
    }

    return Object.assign({}, searchParameters);
  }

  function getValueByKey(key) {
    var parameters = getSearchParameters();
    return parameters[key];
  }

  function setValueByKey(key, value) {
    if (searchParameters[key] === value) {
      return;
    }

    searchParameters[key] = value;
  }

  function setSearchParameters(parameters) {
    Object.assign(searchParameters, parameters);
  }

  return {
    default: defaultSearchParams,
    get: getSearchParameters,
    getByKey: getValueByKey,
    set: setSearchParameters,
    setByKey: setValueByKey,
    uniqueDefaultParams: getParametersConfig
  }
})
;
